let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5fBDT")).then(() => parcelRequire('3m5cp'));